module.exports = __webpack_public_path__ + "static/A-69baf91a27d0a0431a798d96fbe5e844.jpg";